export default __webpack_public_path__ + "static/media/intelligent-quality.9f93a1b8.svg";